import { useEffect } from 'react';
import Privacidade from  '../../components/PolicaPrivacidade'

function PoliticaPrivacidade () {

    useEffect (() => {
        document.title = 'Política de Privacidade | Gesttor'
    }, [])

  return (
      <Privacidade />
  )
}

export default PoliticaPrivacidade;